import { useState } from "react";
import { toast } from "react-toastify";
import apiClient from "../../../api/apiClient";
import { handleErrors } from "../../../modules/handleErrors";
import { generateUUID } from "../utils/helpers";

export const useFormSubmission = (
  stepperFormdata,
  mocko_id,
  fetchFeaturedMockups,
  onHide,
) => {
  const [loader, setloader] = useState(false);

  const handelSubmit = async (e) => {
    if (e) e.preventDefault();

    const uploaddata = new FormData();

    uploaddata.append("ai_models", stepperFormdata?.ai_models);
    uploaddata.append("is_published", stepperFormdata?.is_published);
    uploaddata.append("long_description", stepperFormdata?.long_description);

    if (!stepperFormdata?.is_free) {
      uploaddata.append("price", stepperFormdata.price);
    }

    uploaddata.append(
      "linked_print_provider",
      stepperFormdata?.linked_print_provider,
    );

    const sharable_link_id =
      stepperFormdata?.sharable_link_id ?? generateUUID();

    uploaddata.append("sharable_link_id", sharable_link_id);

    uploaddata.append("linked_product", stepperFormdata?.linked_product);
    uploaddata.append("short_description", stepperFormdata?.short_description);
    uploaddata.append("title", stepperFormdata?.title);
    uploaddata.append("category", stepperFormdata?.category);
    uploaddata.append("subcategory", stepperFormdata?.subcategory);

    if (stepperFormdata?.subsubcategory) {
      uploaddata.append("subsubcategory", stepperFormdata?.subsubcategory);
    }

    if (
      stepperFormdata?.compressed_file &&
      typeof stepperFormdata?.compressed_file == "object"
    ) {
      uploaddata.append("compressed_file", stepperFormdata?.compressed_file);
      // New uploads have no compressed PSD (it was produced by Photopea).
      if (stepperFormdata?.compressed_json_file instanceof Blob) {
        uploaddata.append(
          "compressed_json_file",
          stepperFormdata?.compressed_json_file,
        );
      }
    }

    uploaddata.append(
      "use_main_file_as_thumbnail",
      stepperFormdata?.use_main_file_as_thumbnail,
    );

    uploaddata.append("is_free", stepperFormdata?.is_free);

    if (typeof stepperFormdata?.file == "object") {
      uploaddata.append("file", stepperFormdata?.file);
      uploaddata.append("json_file", stepperFormdata?.json_file);
      // A new PSD replaces any stale compressed copy of the previous one
      // (an empty value clears the nullable field).
      if (!(stepperFormdata?.compressed_json_file instanceof Blob)) {
        uploaddata.append("compressed_json_file", "");
      }
      // Pre-converted mockup templates for the editor; cleared when missing so
      // a previous PSD's templates are never kept.
      const hasTemplates =
        stepperFormdata?.template_preview instanceof Blob &&
        stepperFormdata?.template_full instanceof Blob &&
        stepperFormdata?.template_version;
      uploaddata.append("template_preview", hasTemplates ? stepperFormdata.template_preview : "");
      uploaddata.append("template_full", hasTemplates ? stepperFormdata.template_full : "");
      uploaddata.append("template_thumb", hasTemplates && stepperFormdata?.template_thumb instanceof Blob ? stepperFormdata.template_thumb : "");
      uploaddata.append("template_version", hasTemplates ? String(stepperFormdata.template_version) : "");
    }

    if (
      typeof stepperFormdata?.Design === "object" &&
      stepperFormdata?.Design
    ) {
      uploaddata.append("design", stepperFormdata?.Design);
    }

    uploaddata.append("canva", JSON.stringify(stepperFormdata?.canva));
    uploaddata.append(
      "compressed_canva",
      JSON.stringify(stepperFormdata?.compressed_canva),
    );

    const tagsToUpload = stepperFormdata.tags.map((tag) =>
      typeof tag === "string" ? tag : tag.name,
    );
    uploaddata.append("tags", JSON.stringify(tagsToUpload));

    stepperFormdata?.thumbnails.forEach((file) => {
      uploaddata.append("thumbnails", file);
    });

    try {
      setloader(true);
      let result;
      if (mocko_id) {
        result = await apiClient.patch(`/listings/${mocko_id}/`, uploaddata);
      } else {
        result = await apiClient.post("/listings/", uploaddata);
      }

      setloader(false);
      if (!result.ok) return handleErrors(result.data);
      fetchFeaturedMockups();
      onHide();
      toast.success("listings added successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Error occurred while adding listing");
    }
  };

  return { handelSubmit, loader };
};
